// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown-root {
  position: relative;
}

.Dropdown-control {
  box-sizing: border-box;
  color: #333;
  cursor: default;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  outline: none;
  padding: 8px 52px 8px 10px;
  transition: all .2s;
  position: relative;
  overflow: hidden;
}

.Dropdown-control:hover {
  box-shadow: 0 1px #0000000f;
}

.Dropdown-control.Dropdown-disabled {
  background: #eee;
}

.Dropdown-arrow {
  content: " ";
  border: 5px solid #0000;
  border-top-color: #999;
  border-bottom-width: 0;
  width: 0;
  height: 0;
  display: block;
  position: absolute;
  top: 14px;
  right: 10px;
}

.is-open .Dropdown-arrow {
  border-width: 0 5px 5px;
  border-color: #0000 #0000 #999;
}

.Dropdown-menu {
  box-sizing: border-box;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
  border: 1px solid #ccc;
  width: 100%;
  max-height: 200px;
  margin-top: -1px;
  position: absolute;
  top: 100%;
  overflow-y: auto;
  box-shadow: 0 1px #0000000f;
}

.Dropdown-menu .Dropdown-group > .Dropdown-title {
  color: #333;
  text-transform: capitalize;
  padding: 8px 10px;
  font-weight: bold;
}

.Dropdown-option {
  box-sizing: border-box;
  color: #333c;
  cursor: pointer;
  padding: 8px 10px;
  display: block;
}

.Dropdown-option:last-child {
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.Dropdown-option:hover, .Dropdown-option.is-selected {
  color: #333;
  background-color: #f2f9fc;
}

.Dropdown-noresults {
  box-sizing: border-box;
  color: #ccc;
  cursor: default;
  padding: 8px 10px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Dropdown/dropdown.css","webpack://./services/frontend/app/components/Dropdown/dropdown.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".Dropdown-root {\n  position: relative;\n}\n\n.Dropdown-control {\n  position: relative;\n  overflow: hidden;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  box-sizing: border-box;\n  color: #333;\n  cursor: default;\n  outline: none;\n  padding: 8px 52px 8px 10px;\n  transition: all 200ms ease;\n}\n\n.Dropdown-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n\n.Dropdown-control.Dropdown-disabled {\n  background: #eee;\n}\n\n.Dropdown-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 0;\n  content: ' ';\n  display: block;\n  height: 0;\n  position: absolute;\n  right: 10px;\n  top: 14px;\n  width: 0;\n}\n\n.is-open .Dropdown-arrow {\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n\n.Dropdown-menu {\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n}\n\n.Dropdown-menu .Dropdown-group > .Dropdown-title {\n  padding: 8px 10px;\n  color: rgba(51, 51, 51, 1);\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.Dropdown-option {\n  box-sizing: border-box;\n  color: rgba(51, 51, 51, 0.8);\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n\n.Dropdown-option:last-child {\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.Dropdown-option:hover {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.Dropdown-option.is-selected {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.Dropdown-noresults {\n  box-sizing: border-box;\n  color: #ccc;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n",".Dropdown-root {\n  position: relative;\n}\n\n.Dropdown-control {\n  box-sizing: border-box;\n  color: #333;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  outline: none;\n  padding: 8px 52px 8px 10px;\n  transition: all .2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.Dropdown-control:hover {\n  box-shadow: 0 1px #0000000f;\n}\n\n.Dropdown-control.Dropdown-disabled {\n  background: #eee;\n}\n\n.Dropdown-arrow {\n  content: \" \";\n  border: 5px solid #0000;\n  border-top-color: #999;\n  border-bottom-width: 0;\n  width: 0;\n  height: 0;\n  display: block;\n  position: absolute;\n  top: 14px;\n  right: 10px;\n}\n\n.is-open .Dropdown-arrow {\n  border-width: 0 5px 5px;\n  border-color: #0000 #0000 #999;\n}\n\n.Dropdown-menu {\n  box-sizing: border-box;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  width: 100%;\n  max-height: 200px;\n  margin-top: -1px;\n  position: absolute;\n  top: 100%;\n  overflow-y: auto;\n  box-shadow: 0 1px #0000000f;\n}\n\n.Dropdown-menu .Dropdown-group > .Dropdown-title {\n  color: #333;\n  text-transform: capitalize;\n  padding: 8px 10px;\n  font-weight: bold;\n}\n\n.Dropdown-option {\n  box-sizing: border-box;\n  color: #333c;\n  cursor: pointer;\n  padding: 8px 10px;\n  display: block;\n}\n\n.Dropdown-option:last-child {\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.Dropdown-option:hover, .Dropdown-option.is-selected {\n  color: #333;\n  background-color: #f2f9fc;\n}\n\n.Dropdown-noresults {\n  box-sizing: border-box;\n  color: #ccc;\n  cursor: default;\n  padding: 8px 10px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
